<template>
    <router-view :model="model" :additional="additional"></router-view>
</template>
<script>
    export default {
        data() {
            return {
                "model": {
                    "resource": {
                        "id": null,
                        "name": null,
                        "description": null,
                        "address": null,
                        "city": null,
                        "floor": null,
                        "bookingTypeName": null
                    },
                    "date": {
                        "date": null,
                        "dateStr": null,
                        "fromHour": null,
                        "fromMinute": null,
                        "toHour": null,
                        "toMinute": null
                    },
                    "durationInMinutesMax": null,
                    "bookableSpots": null,
                    "canBookDevices": null,
                    "department": null,
                    "translations": null
                },
                "additional": {
                    "conditionsLink": null,
                    "redirectUrl": null
                }
            }
        },
        created() {
            let data = this.$parent.$data;
            this.model = data.model;
            this.additional = data.additional;

            this.$store.commit("setFromHour", this.model.date.fromHour);
            this.$store.commit("setFromMinute", this.model.date.fromMinute);
            this.$store.commit("setToHour", this.model.date.toHour);
            this.$store.commit("setToMinute", this.model.date.toMinute);
        }
    }
</script>
<style scoped>
</style>